<div class="notification-dropdown">
  <div class="notification-header">
    <h6 class="notification-header-title">{{ 'Notifications' | translate }}</h6>
    <button *ngIf="notifications.length > 0" class="mark-read-btn" (click)="markAllAsRead()" type="button">
      <i class="ti ti-checks"></i>
      <span>{{ 'Mark all as read' | translate }}</span>
    </button>
  </div>

  <div *ngIf="isLoading && notifications.length === 0" class="notification-state">
    <div class="spinner-border spinner-border-sm text-primary" role="status">
      <span class="visually-hidden">{{ 'Loading...' | translate }}</span>
    </div>
    <span>{{ 'Loading notifications...' | translate }}</span>
  </div>

  <div *ngIf="!isLoading && notifications.length === 0" class="notification-state notification-state--empty">
    <i class="ti ti-bell-off"></i>
    <span>{{ 'No new notifications' | translate }}</span>
  </div>

  <div *ngIf="notifications.length > 0" class="notification-list">
    <div *ngFor="let notification of notifications; trackBy: trackByNotificationId" class="notification-item">
      <span class="notification-icon" [class]="'notification-icon ti ti-' + notification.icon"
        [ngClass]="notification.iconClass"></span>

      <div class="notification-text">
        <div class="notification-title">{{ notification.title | translate }}</div>
        <p class="notification-message">{{ notification.body }}</p>
        <small class="notification-date">
          {{ notification.createdAt ? getRelativeTime(notification.createdAt) : '' }}
        </small>
      </div>

      <button class="mark-read-item-btn" type="button" (click)="markAsRead(notification)"
        [title]="'Mark as read' | translate" [attr.aria-label]="'Mark as read' | translate">
        <i class="ti ti-check"></i>
      </button>
    </div>
  </div>
</div>
